
import useCart from '@/composables/useCart'
import { CartDiscountStatic } from '@/helpers/cart-discount/CartDiscountStatic'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const { addCartDiscount, removeCartDiscount, findCartDiscount } = useCart()

    const saleStrategy = new CartDiscountStatic('SALE', 30)
    const isSaleEnabled = ref(findCartDiscount(saleStrategy.label) !== null)
    const toggleSale = () => {
      if (isSaleEnabled.value === true) {
        removeCartDiscount(saleStrategy)
      } else {
        addCartDiscount(saleStrategy)
      }
      isSaleEnabled.value = !isSaleEnabled.value
    }

    return { isSaleEnabled, toggleSale }
  },
})
